import moment from "moment-jalaali";
class Mapper {
  Calendar(Data, Arr, firstDay, monthLength, step) {
    // let Day = firstDay.Day < 10 ? `0${firstDay.Day}` : firstDay.Day
    // let DayPlus = firstDay.Day + 7 < 10 ? `0${firstDay.Day + 7}` : firstDay.Day + 7
    // let Month = firstDay.Month < 10 ? `0${firstDay.Month + 1}` : firstDay.Month + 1
    // let Year = firstDay.Year
    let startKey = moment(
      new Date(firstDay.Year, firstDay.Month, firstDay.Day)
    ).valueOf();
    let endKey = startKey + 7 * 24 * 60 * 60 * 1000;
    Data.map((avai, i) => {
      let startIndex;
      let endIndex;
      let avaiFromDate = Number(moment(avai.date_time_from).format("D"));
      let avaiFromMonth = Number(moment(avai.date_time_from).format("M") - 1);
      let avaiFromHour = Number(moment(avai.date_time_from).format("H"));
      let avaiFromMinute = Number(moment(avai.date_time_from).format("mm"));
      let avaiToDate = Number(moment(avai.date_time_to).format("D"));
      let avaiToMonth = Number(moment(avai.date_time_to).format("M") - 1);
      let avaiToHour = Number(moment(avai.date_time_to).format("H"));
      let avaiToMinute = Number(moment(avai.date_time_to).format("mm"));
      let fromColumnIndex;
      let toColumnIndex;
      let SlotMonthDate = moment(avai.date_time_to).format("MMDD");
      let MonthPlus = firstDay.Month + 1;
      let fistDayMonthStr = `${MonthPlus < 10 ? "0" + MonthPlus : MonthPlus}${
        firstDay.Day < 10 ? "0" + firstDay.Day : firstDay.Day
      }`;
      if (SlotMonthDate >= fistDayMonthStr) {
        if (avaiToMonth !== firstDay.Month) {
          toColumnIndex = Math.abs(avaiToDate + monthLength - firstDay.Day);
          fromColumnIndex = Math.abs(avaiFromDate + monthLength - firstDay.Day);
        } else {
          toColumnIndex = Math.abs(avaiToDate - firstDay.Day);
          fromColumnIndex = Math.abs(avaiFromDate - firstDay.Day);
        }
      }
      let fromRowIndex;
      let toRowIndex;
      fromRowIndex = avaiFromHour / step;
      toRowIndex = avaiToHour / step;
      if (avaiFromMinute == 30) {
        fromRowIndex = avaiFromHour / step + 1;
      }
      if (avaiToMinute === 30) {
        toRowIndex = avaiToHour / step + 1;
      }
      startIndex =
        Number(fromColumnIndex * 48 + fromRowIndex) > 336
          ? Number(fromColumnIndex * 48 + fromRowIndex) - 336
          : Number(fromColumnIndex * 48 + fromRowIndex);
      endIndex =
        Number(toColumnIndex * 48 + toRowIndex) > 336
          ? Number(toColumnIndex * 48 + toRowIndex) - 336
          : Number(toColumnIndex * 48 + toRowIndex);

      if (isNaN(startIndex) === false && isNaN(endIndex) === false) {
        if (!avai.key) {
          for (let x = startIndex; x < endIndex; x++) {
            if (Arr[x]) {
              Arr[x].ID = avai.ID;
              Arr[x].status = avai.Status;
              Arr[x].initialStatus = avai.initialStatus;
            }
          }
        } else {
          if (startKey <= avai.key && avai.key <= endKey) {
            Arr[avai.Index].ID = avai.ID;
            Arr[avai.Index].status = avai.Status;
          }
        }
      }
    });
  }
  Weekly(TimeSlot, Arr, step) {
    TimeSlot.map((avai) => {
      let StartIndex = avai.Start / step;
      let EndIndex = avai.End / step;
      for (let i = StartIndex; i < EndIndex; i++) {
        if (Arr[i] && !Arr.isUpdated) {
          Arr[i].status = 1;
          Arr[i].isUpdated = true;
        }
        if (Arr[i] && avai.isUpdated === true) {
          Arr[i].status = avai.status;
        }
      }
    });
  }
}
export default new Mapper();
